import React from 'react';
import FontPicker from '../FontPicker';

/**
 * FontFamilyField - Font family selector field
 *
 * @param {Object} props
 * @param {Object} props.field - Field configuration
 * @param {string} props.field.key - Unique field identifier
 * @param {string} props.field.label - Display label
 * @param {any} [props.field.default] - Default value
 * @param {string} [props.field.description] - Optional description text
 * @param {any} props.value - Current value
 * @param {Function} props.onChange - Callback when value changes
 * @param {boolean} [props.disabled] - Whether field is disabled
 * @param {string} [props.error] - Error message to display
 * @param {boolean} [props.compact] - Use compact inline layout
 */
export default function FontFamilyField({ field, value, onChange, disabled = false, error, compact = false }) {
  const currentValue = value ?? field.default ?? '';

  const fontPickerElement = (
    <FontPicker
      value={currentValue}
      onChange={onChange}
      className={disabled ? 'opacity-50 pointer-events-none' : ''}
    />
  );

  // Compact mode: inline label + control
  if (compact) {
    return (
      <div className="flex items-center gap-2 py-0.5">
        <label className="text-xs text-gray-500 w-16 flex-shrink-0 truncate">
          {field.label}
        </label>
        <div className="flex-1 min-w-0">
          {fontPickerElement}
        </div>
      </div>
    );
  }

  // Standard mode: stacked layout
  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">
        {field.label}
      </label>
      {fontPickerElement}
      {field.description && (
        <p className="mt-1 text-xs text-gray-500">{field.description}</p>
      )}
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}
